


































































































































































































































































































































































































































































































import {
  staffDetail,
  relationMenu,
  roleslist,
  modifyInfo,
  staffcreate,
  staffInfoData,
  modifyInfoData,
  createInfoData,
  rolesDataAuthority,
  defaultImgApi,
} from "@/api/staffData";
import avatarCliper from "@/components/avatarCliper.vue";
import { bookSelectListApi } from "@/api/book";
import { addsex, addStudentHeader } from "@/api/studentManage";
import { autoSearchData, getSeleSubjectsList } from "@/api/globalSearch";
import { RouterModule } from "@/store/module/router";
import { UserModule } from "@/store/module/user";
import { Component, Vue } from "vue-property-decorator";
import dataAuthority from "../identitySettings/dataAuthority.vue";
import bookSelector from "./bookSelector/index.vue";
import { phonePass } from "@/utils/rules";
import selectRegionPhoneNumber from "@/components/selectRegionPhoneNumber.vue";
import { PageModule } from "@/store/module/page";
@Component({
  name: "editemployee",
  components: {
    avatarCliper,
    dataAuthority,
    bookSelector,
    selectRegionPhoneNumber,
  },
})
export default class extends Vue {
  weekArr: any = [
    {
      day: "星期一",
      id: 1,
      checkDay: false,
    },
    {
      day: "星期二",
      id: 2,
      checkDay: false,
    },
    {
      day: "星期三",
      id: 3,
      checkDay: false,
    },
    {
      day: "星期四",
      id: 4,
      checkDay: false,
    },
    {
      day: "星期五",
      id: 5,
      checkDay: false,
    },
    {
      day: "星期六",
      id: 6,
      checkDay: false,
    },
    {
      day: "星期日",
      id: 0,
      checkDay: false,
    },
  ];
  maxNum: number = 11;
  areaCodePhone = {
    checked: true,
    code: "86",
    code_id: 1,
    en_name: "China",
    name: "中国大陆",
  };
  idCardIndex = true;
  searchInfo = {
    is_live: 0,
    teach_machine: 0,
    subjectsname: [],
    avatar: "",
    avatar_url: "",
    book_auth: 1,
    book_list: [] as {}[],
    phoneNumber: 0,
    is_teach: false,
    eduTeacher: false,
    teachTeacher: false,
    principal: false,
    market: false,
    org_id: 0,
    directly_under: 0,
    full_time: 1,
  };
  sexList = [];
  options = [];
  subjectsList = [];
  subjectsListdata = [];
  role_ids = [];
  roleDataList = [];
  checkedKeys = [];
  roleslistData = [];
  placeholderData = "请选择科目";
  defaultProps = {
    children: "children",
    label: "name",
  }; //定义选中盒子的字段
  rules = {
    name: [{ required: true, message: "请输入员工姓名", trigger: "blur" }],
    mobile: [{ required: true, validator: phonePass, trigger: "blur" }],
  };
  imageUrl = "";
  optionChooseDatas = [];
  authorityList = [];
  get userInfo() {
    return UserModule.userInfo;
  }
  created() {
    const _t = this as any;
    _t.id = Number(_t.$route.query.id);
    if (_t.id != 0) {
      _t.staffDetailData(
        {
          staff_id: _t.id,
        },
        () => {
          _t.postRolesDataAuthority();
          _t.relationMenuData();
          _t.getroleslist();
          _t.globalSearch();
        }
      );
    } else {
      _t.globalSearch();
      defaultImgApi().then((res: any) => {
        if (res.error_code === 0) {
          _t.searchInfo.source_avatar_url = res.data.avatar_url;
          _t.searchInfo.avatar = res.data.avatar;
        }
      });
    }
    _t.getFormList(addsex, "sexList");
    if (_t.id == 0) {
      _t.getHead();
      _t.getroleslist();
    }
  }
  // handleTeacherRest(val:any) {
  //   this.weekArr.map((it:any) => {
  //     if (it.id === val.id) {
  //       it.checkDay = !it.checkDay;
  //     }
  //   })
  // }
  handleChangeSwitch(val: string) {
    if (val === "teachTeacher" && this.searchInfo.teachTeacher === false) {
      this.$confirm("此操作不能撤销。确定要关闭吗？", "关闭 - 课程顾问", {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        type: "warning",
      })
        .then(() => {
          this.searchInfo.teachTeacher = false;
        })
        .catch(() => {
          this.searchInfo.teachTeacher = true;
        });
    } else if (val === "eduTeacher" && this.searchInfo.eduTeacher === false) {
      this.$confirm("此操作不能撤销。确定要关闭吗？", "关闭 - 教务老师", {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        type: "warning",
      })
        .then(() => {
          this.searchInfo.eduTeacher = false;
        })
        .catch(() => {
          this.searchInfo.eduTeacher = true;
        });
    } else if (val === "is_teach" && this.searchInfo.is_teach === false) {
      this.$confirm("此操作不能撤销。确定要关闭吗？", "关闭 - 授课老师", {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        type: "warning",
      })
        .then(() => {
          this.searchInfo.is_teach = false;
          if (!this.searchInfo.market && !this.searchInfo.is_teach) {
            this.searchInfo.full_time = 1;
          }
        })
        .catch(() => {
          this.searchInfo.is_teach = true;
        });
    } else if (val === "principal" && this.searchInfo.principal === false) {
      this.$confirm("此操作不能撤销。确定要关闭吗？", "关闭 - 校长", {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        type: "warning",
      })
        .then(() => {
          this.searchInfo.principal = false;
        })
        .catch(() => {
          this.searchInfo.principal = true;
        });
    } else if (val === "market" && this.searchInfo.market === false) {
      this.$confirm(
        "关闭市场顾问岗位后，该员工将自动移除对应的数据权限，此操作不能撤销。确定要关闭吗？",
        "关闭 - 市场顾问",
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          type: "warning",
        }
      )
        .then(() => {
          this.searchInfo.market = false;
          if (!this.searchInfo.market && !this.searchInfo.is_teach) {
            this.searchInfo.full_time = 1;
          }
        })
        .catch(() => {
          this.searchInfo.market = true;
        });
    }
  }
  optionChooseData(e: any) {
    this.optionChooseDatas = e;
  }
  changeIsNeedCaptcha(e: any) {
    const _t = this as any;
    if (e == true) {
      _t.$confirm(`此操作不能撤销。确定要关闭吗？`, `关闭 - 老师授课`, {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        type: "warning",
      })
        .then(() => {
          _t.searchInfo.is_live = 0;
          _t.searchInfo.teach_machine = 0;
          _t.searchInfo.is_teach = false;
        })
        .catch(() => {});
    } else {
      _t.searchInfo.is_teach = true;
    }
  }
  // 创建员工时，选中教学机，自动设置为授权全部
  handleTeachMachineChecked(e: boolean) {
    if (e && this.searchInfo.book_list.length === 0) {
      bookSelectListApi({
        page: 1,
        page_size: 1000,
      }).then((res: any) => {
        this.searchInfo.book_list = res.data.list;
        this.searchInfo.book_auth = 1;
      });
    }
  }
  // 授权教材
  handleBookSelect(data: { type: number; list: {}[] }) {
    this.searchInfo.book_auth = data.type;
    this.searchInfo.book_list = data.list;
  }
  // 头像弹窗返回
  handleAvatarChange(key: string) {
    this.searchInfo.avatar = key;
  }
  //获取头像
  getHead() {
    addStudentHeader().then((res: any) => {
      const _t = this as any;
      if (res.error_code == 0) {
        _t.imageUrl =
          res.data.list[Math.floor(Math.random() * res.data.list.length)];
        _t.searchInfo.avatar_url = _t.imageUrl.avatar_url;
        _t.searchInfo.avatar = _t.imageUrl.avatar;
      }
    });
  }
  setCover(res: any) {
    const _t = this as any;
    _t.searchInfo.avatar = res.data.object;
  }
  getroleslist() {
    const _t = this as any;
    roleslist().then((res: any) => {
      if (res.error_code == 0) {
        const allroleList: any = [];
        if (res.data.system != null) {
          res.data.system.map((a: any) => {
            a.system = true;
          });
        }
        allroleList.push(...res.data.system);
        allroleList.push(...res.data.custom);
        allroleList.map((a: any) => {
          a.choosecurrent = false;
          _t.role_ids.map((role_ids: number) => {
            if (role_ids == a.role_id) {
              a.choosecurrent = true;
            }
          });
        });
        _t.roleslistData = allroleList;
      }
    });
  }
  clickChoosebox(e: any) {
    const _t = this as any;
    if (_t.role_ids.indexOf(e.role_id) == -1) {
      _t.role_ids.push(e.role_id);
      e.choosecurrent = true;
    } else {
      _t.role_ids.splice(_t.role_ids.indexOf(e.role_id), 1);
      e.choosecurrent = false;
    }
    if (_t.role_ids.length > 0) {
      _t.relationMenuData();
      _t.postRolesDataAuthority();
    } else {
      _t.checkedKeys.length = 0;
    }
  }
  clickphototips() {
    const _t = this as any;
    _t.$confirm(
      `你将打开角色身份添加页面，当前页面填写的数据将丢失，确定继续打开？`,
      `打开 - 添加身份`,
      {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        type: "warning",
      }
    )
      .then(() => {
        _t.$router.push({ name: "employeeManage", query: { type: "add" } });
      })
      .catch(() => {});
  }
  //获取表单列表
  getFormList(cb: Function, type: any) {
    const _t = this as any;
    cb().then((res: any) => {
      if (res.error_code == 0) {
        _t[type] = res.data.list;
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  async globalSearch(queryString: string | null) {
    const params: any = {
      page: 1,
      page_size: 500,
      status: 1,
    };
    if (queryString) {
      params.title = queryString;
    }
    getSeleSubjectsList(params).then((res) => {
      this.subjectsList = res.data.list;
    });
  }
  staffDetailData(params: { staff_id: number; org_id?: number }, cb: Function) {
    const _t = this as any;
    // 如果query中带有机构id，则表示正在关联新员工
    const oid = _t.$route.query.org_id;
    if (oid) {
      params.org_id = oid;
    }
    staffDetail(params).then((res: any) => {
      if (res.error_code == 0) {
        res.data.is_teach = res.data.is_teach == 1 ? true : false;
        res.data.is_live = res.data.is_live == 1 ? true : false;
        res.data.teach_machine = res.data.teach_machine == 1 ? true : false;
        res.data.teach_machine = res.data.teach_machine == 1 ? true : false;
        if (res.data.jobs) {
          res.data.jobs.map((item: any) => {
            if (item.job_id === 1) {
              res.data.is_teach = true;
            } else if (item.job_id === 2) {
              res.data.eduTeacher = true;
            } else if (item.job_id == 3) {
              res.data.teachTeacher = true;
            } else if (item.job_id == 4) {
              res.data.market = true;
            } else if (item.job_id == 5) {
              res.data.principal = true;
            }
          });
        }
        if (res.data.resting_time) {
          res.data.resting_time.map((item: any) => {
            this.weekArr.map((it: any) => {
              if (item === it.id) {
                it.checkDay = true;
              }
            });
          });
        }
        res.data.avatar = res.data.avatar === "" ? "" : res.data.avatar;
        res.data.source_avatar_url =
          res.data.avatar_url === "" ? "" : res.data.avatar_url;
        const newarry = res.data.subjects;
        newarry.map((a: any, b: number) => {
          newarry[b]["subject_id"] = newarry[b]["key"];
          newarry[b]["subject_title"] = newarry[b]["value"];
          _t.subjectsListdata[b] = newarry[b]["key"];
          delete newarry[b]["key"];
          delete newarry[b]["value"];
        });
        if (_t.subjectsListdata.length > 0) {
          _t.placeholderData = "";
        }
        _t.subjectsList = newarry;
        if (res.data.area_code) {
          PageModule.SET_PAGE_INFO({
            name: "areaCodePhoneNumber",
            key: "area_code",
            value: res.data.area_code,
          });
        }
        _t.areaCodePhone.code = res.data.area_code;
        _t.searchInfo = res.data;
        _t.role_ids = res.data.roles;
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
      if (cb) {
        cb();
      }
    });
  }
  placeholderFocus() {
    const _t = this as any;
    if (_t.subjectsListdata.length == 0) {
      _t.placeholderData = "请选择科目";
    }
  }
  goBack() {
    this.$router.go(-1);
  }
  relationMenuData() {
    const _t = this as any;
    const role_ids = _t.role_ids.join(",");
    relationMenu({ role_ids: role_ids }).then((res: any) => {
      if (res.error_code == 0) {
        _t.checkedKeys.length = 0;
        _t.roleDataList = res.data.list;
        _t.itemGetid(res.data.list);
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  postRolesDataAuthority() {
    const _t = this as any;
    rolesDataAuthority({ roles: _t.role_ids }).then((res: any) => {
      if (res.error_code == 0) {
        _t.authorityList = res.data.list;
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  itemGetid = (itemData: any) => {
    const _t = this as any;
    itemData.map((item: any) => {
      if (item.is_select) {
        if (item.children == null) {
          _t.checkedKeys.push(item.menu_id);
        }
      }
      if (item.children != null) {
        _t.itemGetid(item.children);
      }
      item.disabled = true;
    });
  };
  postData() {
    const _t = this as any;
    const data: staffInfoData = {
      name: _t.searchInfo.name,
      mobile: _t.searchInfo.mobile,
      teach_machine: _t.searchInfo.teach_machine ? 1 : 2,
      roles: [],
      remark: _t.searchInfo.remark,
      book_auth: _t.searchInfo.book_auth,
      book_ids: [],
      area_code: _t.areaCodePhone.code,
      full_time: _t.searchInfo.full_time,
    };
    const arr = [];
    if (_t.searchInfo.is_teach) {
      arr.push(1);
    }
    if (_t.searchInfo.eduTeacher) {
      arr.push(2);
    }
    if (_t.searchInfo.teachTeacher) {
      arr.push(3);
    }
    if (_t.searchInfo.principal) {
      arr.push(5);
    }
    if (_t.searchInfo.market) {
      arr.push(4);
    }
    data.job_ids = arr;
    data.avatar = _t.searchInfo.avatar;
    data.sex = Number(_t.searchInfo.sex);
    data.subjects = _t.subjectsListdata;

    if (_t.searchInfo.book_auth === 1) {
      data.book_ids = [];
    } else {
      data.book_ids = _t.searchInfo.book_list.map((item: any) => {
        return item.book_id;
      });
    }
    if (!_t.searchInfo.name) {
      _t.$message({
        type: "error",
        message: "请输入员工姓名!",
      });
      return;
    }
    if (!_t.searchInfo.mobile) {
      _t.$message({
        type: "error",
        message: "请输入手机号!",
      });
      return;
    }
    if (_t.role_ids.length == 0) {
      _t.$message({
        type: "error",
        message: "请选择角色身份!",
      });
      return;
    } else {
      data.roles = _t.role_ids;
    }
    const newWeekArr: number[] = [];
    // 固定休息数组
    this.weekArr.map((it: any) => {
      if (it.checkDay) {
        newWeekArr.push(it.id);
      }
    });
    if (newWeekArr.length > 0) {
      data.resting_time = newWeekArr;
    }
    // return;
    _t.$refs["formployee"].validate((valid: any) => {
      if (valid) {
        const id = Number(_t.$route.query.id);
        const oid = Number(_t.$route.query.org_id);
        // 新建
        if (id === 0) {
          const cdata: createInfoData = data;
          staffcreate(cdata).then((res: any) => {
            if (res.error_code == 0) {
              // 成功，邀请加入
              _t.$alert(
                `${data.name}员工资料已添加完成，请复制邀请链接发给员工授权加入。`,
                `邀请加入-${data.name}`,
                {
                  confirmButtonText: "复制邀请链接",
                  callback: () => {
                    const link = res.data.activate_url;
                    navigator.clipboard.writeText(link).then(() => {
                      _t.$message({
                        type: "success",
                        message: "复制成功",
                      });
                    });
                    _t.goBack();
                  },
                }
              );
            } else {
              _t.$message({
                type: "error",
                message: res.message,
              });
            }
          });
        } else {
          if (oid) {
            // 正在为门店关联新员工
            const cdata: createInfoData = data;
            cdata.staff_id = id;
            staffcreate(cdata).then((res: any) => {
              if (res.error_code == 0) {
                _t.$message({
                  type: "success",
                  message: `关联成功!`,
                });
                _t.goBack();
              } else {
                _t.$message({
                  type: "error",
                  message: res.message,
                });
              }
            });
          } else {
            // 无oid代表直属员工编辑
            const mdata: modifyInfoData = {
              ...data,
              staff_id: id,
            };
            modifyInfo(mdata).then((res: any) => {
              if (res.error_code == 0) {
                _t.$message({
                  type: "success",
                  message: "修改成功!",
                });
                _t.staffDetailData(
                  {
                    staff_id: _t.id,
                  },
                  () => {
                    _t.getFormList(addsex, "sexList");
                    _t.getroleslist();
                    _t.relationMenuData();
                    _t.postRolesDataAuthority();
                  }
                );
                _t.goBack();
                if (_t.id === UserModule.userInfo.staff_id) {
                  // 修改自己后重新获取一遍个人信息和菜单
                  RouterModule.SetAsyncRouter();
                }
              } else {
                _t.$message({
                  type: "error",
                  message: res.message,
                });
              }
            });
          }
        }
      } else {
        return false;
      }
    });
  }
  areaCode(data: any) {
    PageModule.SET_PAGE_INFO({
      name: "areaCodePhoneNumber",
      key: "area_code",
      value: data[0].code,
    });
    if (data) {
      this.areaCodePhone = data[0];
      if (
        data[0].code !== "86" &&
        data[0].code !== "852" &&
        data[0].code !== "853" &&
        data[0].code !== "886"
      ) {
        this.maxNum = 16;
        return;
      } else if (data[0].code === "852" || data[0].code === "853") {
        this.maxNum = 8;
        return;
      } else if (data[0].code === "886") {
        this.maxNum = 10;
        return;
      } else {
        this.maxNum = 11;
        return;
      }
    }
  }
  beforeDestroy() {
    PageModule.SET_PAGE_INFO({
      name: "areaCodePhoneNumber",
      key: "area_code",
      value: "",
    });
  }
}
